const FlexTimeAPI = {
  API_ROOT_URL: '/flex-time'
};

export default FlexTimeAPI;
